import { actionTypes } from "../actions/analytics";

const variable = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PROJECT_ANALYSIS:
      return action.payload;
    default:
      return state;
  }
};

export default variable;